var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57031 0.945312H26.4453C27.2189 0.945313 27.9607 1.2526 28.5077 1.79958C29.0547 2.34657 29.362 3.08843 29.362 3.86198V8.23698C29.362 9.01053 29.0547 9.75239 28.5077 10.2994C27.9607 10.8464 27.2189 11.1536 26.4453 11.1536H23.5286V15.5286C23.5286 17.0757 22.9141 18.5595 21.8201 19.6534C20.7261 20.7474 19.2424 21.362 17.6953 21.362H8.94531C7.39822 21.362 5.91449 20.7474 4.82052 19.6534C3.72656 18.5595 3.11198 17.0757 3.11198 15.5286V2.40365C3.11198 2.01687 3.26563 1.64594 3.53912 1.37245C3.81261 1.09896 4.18354 0.945313 4.57031 0.945312ZM23.5286 3.86198V8.23698H26.4453V3.86198H23.5286ZM0.195312 24.2786H26.4453V27.1953H0.195312V24.2786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreak);
export default __webpack_public_path__ + "static/media/break.789137fc849458a8eda4b388ba9293e8.svg";
export { ForwardRef as ReactComponent };